import { defineSemanticTokens } from '@chakra-ui/react/styled-system';

export const shadows = defineSemanticTokens.shadows({
	xs: {
		value: { _light: '0px 0px 0px 1px rgba(0, 0, 0, 0.05)', _dark: '0px 0px 0px 1px rgba(0, 0, 0, 0.4)' },
	},
	sm: {
		value: { _light: '0px 1px 2px 0px rgba(0, 0, 0, 0.05)', _dark: '0px 1px 2px 0px rgba(0, 0, 0, 0.2)' },
	},
	'sm-up': {
		value: { _light: '0px -1px 2px 0px rgba(0, 0, 0, 0.05)', _dark: '0px -1px 2px 0px rgba(0, 0, 0, 0.4)' },
	},
	md: {
		value: {
			_light: '0px 2px 4px -1px rgba(0, 0, 0, 0.06), 0px 4px 6px -1px rgba(0, 0, 0, 0.1)',
			_dark: '0px 2px 4px -1px rgba(0, 0, 0, 0.1), 0px 4px 6px -1px rgba(0, 0, 0, 0.2)'
		}
	},
	'md-up': {
		value: {
			_light: '0px -4px 6px -1px rgba(0, 0, 0, 0.06), 0px -2px 4px -1px rgba(0, 0, 0, 0.06)',
			_dark: '0px -4px 6px -1px rgba(0, 0, 0, 0.03), 0px -2px 4px -1px rgba(0, 0, 0, 0.2)'
		}
	},
	lg: {
		value: {
			_light: '0px 4px 6px -2px rgba(0, 0, 0, 0.05), 0px 10px 15px -3px rgba(0, 0, 0, 0.1)',
			_dark: '0px 4px 6px -2px rgba(0, 0, 0, 0.3), 0px 10px 15px -3px rgba(0, 0, 0, 0.4)'
		}
	},
	'lg-up': {
		value: {
			_light: '0px -4px 6px -2px rgba(0, 0, 0, 0.05), 0px -10px 15px -3px rgba(0, 0, 0, 0.1)',
			_dark: '0px -4px 6px -2px rgba(0, 0, 0, 0.3), 0px -10px 15px -3px rgba(0, 0, 0, 0.4)'
		}
	},
	xl: {
		value: {
			_light: '0px 10px 10px -5px rgba(0, 0, 0, 0.04), 0px 20px 25px -5px rgba(0, 0, 0, 0.1)',
			_dark: '0px 10px 10px -5px rgba(0, 0, 0, 0.3), 0px 20px 25px -5px rgba(0, 0, 0, 0.4)'
		}
	},
	'2xl': {
		value: '0px 25px 50px -12px rgba(0, 0, 0, 0.25)'
	},
	inner: {
		value: 'inset 0px 2px 4px 0px rgba(0, 0, 0, 0.06)'
	},
	'dark-lg': {
		value: '0px 15px 40px 0px rgba(0, 0, 0, 0.4), 0px 5px 10px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 1px rgba(0, 0, 0, 0.1)'
	}
});
